function upperCaseText(text, upperCase) {
    if (!text) { return '' }
    let newText = String(text.replace("_", " "))
    return upperCase ? newText.toUpperCase() : newText.charAt(0).toUpperCase() + newText.slice(1);
}

function mappingType (listingType) {
    if (listingType == "sell") { return "Jual" }
    if (listingType == "rent") { return "Sewa" }
    return ""
}

function mappingStatus (listingType) {
    if (listingType == "new") { return "Baru" }
    if (listingType == "secondary") { return "Secondary" }
    return ""
}

export { upperCaseText, mappingType, mappingStatus }